import { useState } from 'react';
import useAuth from '@/domains/auth/hooks/useAuth';
import ConfirmModal from '@/domains/dashboard-management/components/ConfirmModal/ConfirmModal';
import { showToast } from '@/shared/utils/showToast';

interface LogoutConfirmModalProps {
  open: boolean;
  onClose: () => void;
}

/** "Keluar Akun?" confirmation of the dashboard Sidebar and Header (same as Akun Saya). */
const LogoutConfirmModal = ({ open, onClose }: LogoutConfirmModalProps) => {
  const { handleLogout } = useAuth();
  const [loggingOut, setLoggingOut] = useState(false);

  const confirmLogout = () => {
    setLoggingOut(true);
    handleLogout().catch((error: Error) => {
      setLoggingOut(false);
      onClose();
      showToast({ type: 'error', title: 'Gagal keluar akun', message: error.message });
    });
  };

  return (
    <ConfirmModal
      open={open}
      title="Keluar Akun?"
      message="Apakah Anda yakin ingin keluar akun?"
      confirmLabel="Ya, Keluar"
      variant="danger"
      loading={loggingOut}
      onConfirm={confirmLogout}
      onClose={onClose}
    />
  );
};

export default LogoutConfirmModal;
